<template>
  <div class="content">
    <div v-html="data"></div>
  </div>
</template>

<script>
/**
@description:id = 2 用户协议  = 3怎么赚钱
@createTime:2021-09-23
@create:wq
*/
import { formatRichText } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      data: "",
      id:'',
      title:''
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.id = this.$route.query.i;
    this.pages();
  },
  methods: {
    pages() {
      this.api.pages({ id: this.id }).then((res) => {
        if (res.data.contents) {
          // this.data = formatRichText(res.data.contents);
          this.data = res.data.contents;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
  // margin: 0 0.24rem;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}
/deep/ img{
  display: block;
  width: 100%;
}
</style>
